module.exports = "<div *ngIf=\"isVisible\">\n  <mat-progress-bar [mode]=\"mode\"></mat-progress-bar>\n</div>"